var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-tip",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._v(" 点击右上角分享给好友，邀请好友入团 "),_c('img',{attrs:{"src":require("../../../assets/share.png")}})])
}]

export { render, staticRenderFns }